import React from 'react'
import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Box,
} from '@mui/material'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined'
import { useColorMode } from '@/theme/ColorModeProvider'
import { colorModeToggleIconWrapSx } from '@/layout-blueprints/chromeComponentSx'

const OPTIONS = [
  {
    value: 'light',
    label: 'Light',
    icon: <LightModeOutlinedIcon fontSize="small" />,
  },
  {
    value: 'dark',
    label: 'Dark',
    icon: <DarkModeOutlinedIcon fontSize="small" />,
  },
  {
    value: 'auto',
    label: 'Auto',
    icon: <SettingsBrightnessOutlinedIcon fontSize="small" />,
  },
]

/**
 * Compact Light / Dark / Auto control. Requires ColorModeProvider ancestor.
 */
export default function ColorModeToggle({ size = 'small', sx  }) {
  const { preference, setPreference } = useColorMode()

  return (
    <ToggleButtonGroup
      exclusive
      size={size}
      value={preference}
      onChange={(_event, next) => {
        if (next) setPreference(next)
      }}
      aria-label="Color mode"
      sx={{
        backgroundColor: 'action.hover',
        ...sx,
      }}
    >
      {OPTIONS.map((option) => (
        <ToggleButton
          key={option.value}
          value={option.value}
          aria-label={option.label}
        >
          <Tooltip title={option.label}>
            <Box component="span" sx={colorModeToggleIconWrapSx}>
              {option.icon}
            </Box>
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
